import {Controller} from '@stubhub/react-store-provider';

import {
  NAMESPACE,
  currentLocaleSelector,
  dateFilterSelector,
  datePickerEnabledSelector,
  queryParamsEnabledSelector,
} from './selectors';
import {storeUserSelectedDate} from './storage-cookie';

/**
 * Stores active date filter selection into cookies and dispatches a reducer
 * to update props.
 * @param {Object} dateFilter Date filter selected item.
 */
function onSelection(dateFilter) {
  return (dispatch, getState, {cookies}) => {
    const currentFilter = dateFilterSelector(getState());
    if (currentFilter.key === dateFilter.key) {
      return;
    }

    storeUserSelectedDate(cookies, dateFilter);
    dispatch({type: 'USER_DATE_FILTER_CHANGED', date: dateFilter});
  };
}

/**
 * A DateFilter component's controller.
 */
const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    return {
      dateFilter: dateFilterSelector(state),
      isDatePickerEnabled: datePickerEnabledSelector(state),
      areQueryParamsEnabled: queryParamsEnabledSelector(state),
      currentLocale: currentLocaleSelector(state),
    };
  },
  actionCreators: {
    onSelection,
  },
  reducers: ['USER_DATE_FILTER_CHANGED'],
});

export default controller;
